(function () {
  "use strict";
  var CONFIG = {
      productUrl: "/products/kiddospace-ateranvandbara-vattensvampbollar",
      exitUrl: "/pages/9-reasons-why-water-sponge-balls",
      logoUrl:
        "https://thekiddospacestore.com/cdn/shop/files/New_logo_118x_2x_8455129b-5f9c-4cc5-8d47-906d4b391699_118x.png?v=1746770607",
      topBarText: "Sätt ihop rätt set för din familj!",
      trustLine: "3 500+ nöjda familjer med 90 dagars garanti",
      fixedKit: {
        name: "Ditt sommarsplash-setup är upplåst",
        tagline:
          "Bäst för övervakad utomhuslek på platt gräs eller en mjuk utomhusmatta.",
        price: "\xA329.99",
        comparePrice: "\xA349.99",
        savings: "Du sparar \xA320 idag",
        variantId: "REPLACE_WITH_VARIANT_ID_1",
        image:
          "https://thekiddospacestore.co.uk/cdn/shop/files/1-Web-Images--Splash-Pad_900x900_4c00c416-6fc4-4c78-830c-d7ef336b8c72_720x720.jpg",
        perks: [
          "Ditt vattenstrids-setup kontrolleras",
          "10 extra vattensvampbollar läggs till gratis",
          "2 nätpåsar läggs till gratis",
          "90 dagars pengarna-tillbaka-garanti",
        ],
        reviews: [
          {
            text: "My grandkids absolutely love these! No more balloon mess on the lawn.",
            author: "Sandra M.",
            status: "verified buyer \u2714",
          },
          {
            text: "Best purchase this summer. My kids fight over who gets to refill them!",
            author: "Jennifer R.",
            status: "verified buyer \u2714",
          },
          {
            text: "Used these at my grandson's birthday, 15 kids going wild for 3 hours. Zero cleanup!",
            author: "Robert K.",
            status: "verified buyer \u2714",
          },
        ],
      },
      loadingItems: [
        "Ditt vattenstrids-setup kontrolleras",
        "10 extra vattensvampbollar läggs till gratis",
        "2 nätpåsar läggs till gratis",
        "90 dagars pengarna-tillbaka-garanti",
      ],
      steps: [
        {
          id: "who",
          eyebrow: "Fråga 1 av 5",
          question: "Vem köper du det till?",
          subtext: "Detta hjälper oss att hitta rätt passform för din familj.",
          options: [
            {
              value: "My grandkids",
              icon: "\uD83D\uDC75",
              label: "Mina barnbarn",
              desc: "Mina barnbarn",
            },
            {
              value: "My own kids",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Mina barn",
              desc: "Mina barn",
            },
            {
              value: "For a party or event",
              icon: "\uD83C\uDF89",
              label: "Till en fest eller ett event",
              desc: "Till en fest eller ett event",
            },
            {
              value: "It's a gift",
              icon: "\uD83C\uDF81",
              label: "Som present",
              desc: "Som present",
            },
          ],
        },
        {
          id: "count",
          eyebrow: "Fråga 2 av 5",
          question: "Hur många barn leker vanligtvis samtidigt?",
          subtext: "Räkna med alla som kan tänkas vara med.",
          options: [
            {
              value: "1-2",
              icon: "👦",
              label: "1–2",
            },
            {
              value: "3-4",
              icon: "👧👦",
              label: "3–4",
            },
            {
              value: "5-6",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "5–6",
            },
            {
              value: "7+",
              icon: "\uD83C\uDF8A",
              label: "7+",
            },
          ],
        },
        {
          id: "surface",
          eyebrow: "Fråga 3 av 5",
          question: "Vilka åldersgrupper kommer främst att vara med?",
          subtext: "Underlaget påverkar hur bra den håller sig på plats.",
          options: [
            {
              value: "1-4",
              icon: "\uD83E\uDDF8",
              label: "1–4",
            },
            {
              value: "5-8",
              icon: "\uD83D\uDCA6",
              label: "5–8",
            },
            {
              value: "9-12",
              icon: "\uD83C\uDFC3",
              label: "9–12",
            },
            {
              value: "Mixed ages",
              icon: "\uD83C\uDF08",
              label: "Blandade åldrar",
              desc: "Hjälp mig välja",
            },
          ],
        },
        {
          id: "hose",
          eyebrow: "Fråga 4 av 5",
          question: "Var kommer de att använda den mest?",
          subtext:
            "Splash Pad ansluts direkt till en vanlig trädgårdsslang.",
          options: [
            {
              value: "Garden",
              icon: "\uD83C\uDFE1",
              label: "Trädgård",
            },
            {
              value: "Pool",
              icon: "\uD83C\uDFCA",
              label: "Pool",
            },
            {
              value: "Beach",
              icon: "\uD83C\uDFD6\uFE0F",
              label: "Strand",
            },
            {
              value: "A bit of everything",
              icon: "\uD83C\uDF0D",
              label: "Lite av allt",
            },
          ],
        },
        {
          id: "priority",
          eyebrow: "Fråga 5 av 5",
          question: "Vad är viktigast för dig?",
          subtext: "Välj det som passar bäst.",
          options: [
            {
              value: "No balloon waste to clean up",
              icon: "\uD83E\uDDF9",
              label: "Inget ballongskräp att städa upp",
            },
            {
              value: "Refills in seconds",
              icon: "\uD83D\uDCA7",
              label: "Snabbt påfyllningsbar",
            },
            {
              value: "Enough for the whole group",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Tillräckligt för hela gruppen",
            },
            {
              value: "Easy to store",
              icon: "\uD83D\uDC5C",
              label: "Enkel att förvara",
            },
            {
              value: "Good value for parties",
              icon: "\uD83C\uDFF7\uFE0F",
              label: "Bra värde för fester",
            },
          ],
        },
        {
          id: "alternative",
          eyebrow: "Fråga 6 av 6",
          question: "Vad föredrar du:",
          subtext: "Välj det som passar bäst.",
          options: [
            {
              value: "Just enough",
              icon: "\uD83D\uDC66",
              label: "Precis lagom",
              desc: "Precis lagom",
            },
            {
              value: "A little extra",
              icon: "\u2795",
              label: "Lite extra",
              desc: "Lite extra",
            },
            {
              value: "Cousins and friends",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Tillräckligt för kusiner och vänner",
              desc: "Tillräckligt för kusiner och vänner",
            },
            {
              value: "Party-ready",
              icon: "\uD83C\uDF89",
              label: "Festredo",
              desc: "Festredo",
            },
          ],
        },
      ],
    },
    state = { screen: "intro", currentStep: 0, answers: {} };
  function el(id) {
    return document.getElementById(id);
  }
  var stars = "\u2605\u2605\u2605\u2605\u2605";
  function renderIntro() {
    var pBar = el("quiz-progress-wrap");
    pBar && (pBar.style.display = "none");
    var stage = el("quiz-stage");
    stage &&
      ((stage.innerHTML =
        '<div class="quiz-intro"><div class="quiz-intro-badge"><span class="quiz-intro-dot"></span> Tar bara 1 minut</div><h1 class="quiz-intro-headline">Hitta det perfekta vattenstrids-setet för din familj!</h1><p class="quiz-intro-sub">Svara på 6 korta frågor och få ditt personliga vattensvampsbolls-set – <strong>plus 10 extra vattensvampbollar gratis på köpet!</strong></p><div class="quiz-intro-features"><div class="quiz-intro-feature"><span class="quiz-intro-fi">\uD83C\uDF89</span> Slut på att plocka upp ballongrester</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u26A1</span> Påfyllda på 5 sekunder av sig själva</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u2B50</span> 3 500+ femstjärniga recensioner från familjer</div></div><button class="quiz-btn quiz-intro-btn" id="quiz-start-btn" type="button">Hitta mitt ideala set<span class="quiz-btn-arrow">\u2192</span></button><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
      el("quiz-start-btn").addEventListener("click", function () {
        ((state.screen = "quiz"),
          pBar && (pBar.style.display = ""),
          renderStep(0));
      }));
  }
  function renderProgress(idx) {
    var total = CONFIG.steps.length,
      pct = Math.round((idx / total) * 100),
      wrap = el("quiz-progress-wrap");
    wrap &&
      (wrap.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Ditt set sätts ihop</span><span class="quiz-progress-count">' +
        idx +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:' +
        pct +
        '%"></div></div></div>');
  }
  function optionCard(opt, stepId) {
    var sel = state.answers[stepId] === opt.value;
    return (
      '<button class="quiz-option' +
      (sel ? " selected" : "") +
      '" data-step="' +
      stepId +
      '" data-value="' +
      opt.value +
      '" type="button" aria-pressed="' +
      sel +
      '"><span class="quiz-option-icon">' +
      opt.icon +
      '</span><span class="quiz-option-body"><span class="quiz-option-label">' +
      opt.label +
      '</span><span class="quiz-option-desc">' +
      opt.desc +
      "</span></span></button>"
    );
  }
  function renderStep(idx) {
    var step = CONFIG.steps[idx],
      hasAnswer = !!state.answers[step.id],
      isLast = idx === CONFIG.steps.length - 1,
      stage = el("quiz-stage");
    if (stage) {
      ((stage.innerHTML =
        '<div class="quiz-step"><button class="quiz-back" id="quiz-back-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Tillbaka</button><p class="quiz-eyebrow">' +
        step.eyebrow +
        '</p><h2 class="quiz-question">' +
        step.question +
        '</h2><p class="quiz-subtext">' +
        step.subtext +
        '</p><div class="quiz-options">' +
        step.options
          .map(function (o) {
            return optionCard(o, step.id);
          })
          .join("") +
        '</div><div class="quiz-btn-wrap"><button class="quiz-btn" id="quiz-next-btn" type="button"' +
        (hasAnswer ? "" : " disabled") +
        ">" +
        (isLast ? "Se min rekommendation" : "Fortsätt") +
        ' <span class="quiz-btn-arrow">\u2192</span></button></div><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
        stage.querySelectorAll(".quiz-option").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var stepId = btn.getAttribute("data-step"),
              val = btn.getAttribute("data-value");
            ((state.answers[stepId] = val),
              stage
                .querySelectorAll('.quiz-option[data-step="' + stepId + '"]')
                .forEach(function (b) {
                  var on = b.getAttribute("data-value") === val;
                  (b.classList.toggle("selected", on),
                    b.setAttribute("aria-pressed", on));
                }));
            var nb2 = el("quiz-next-btn");
            nb2 && (nb2.disabled = !1);
          });
        }));
      var nb = el("quiz-next-btn");
      nb && nb.addEventListener("click", advance);
      var bb = el("quiz-back-btn");
      (bb && bb.addEventListener("click", goBack), renderProgress(idx));
    }
  }
  function renderLoading() {
    var pBar = el("quiz-progress-wrap"),
      total = CONFIG.steps.length;
    pBar &&
      (pBar.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Ditt rekommenderade set sätts ihop</span><span class="quiz-progress-count">' +
        total +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
    var stage = el("quiz-stage");
    if (stage) {
      var itemsHtml = CONFIG.loadingItems
        .map(function (text, i) {
          return (
            '<div class="loading-item" id="load-item-' +
            i +
            '"><div class="loading-check" id="load-check-' +
            i +
            '"></div><span>' +
            text +
            "</span></div>"
          );
        })
        .join("");
      stage.innerHTML =
        '<div class="quiz-loading" id="quiz-loading-wrap"><div class="loading-spinner" id="loading-spinner"></div><h2 class="loading-title">Se mitt rekommenderade set \u2026</h2><p class="loading-sub" id="loading-sub">Anpassas baserat på dina svar</p><div class="loading-checklist">' +
        itemsHtml +
        '</div><div id="loading-cta" style="display:none;"><p class="loading-cta-sub">Vi har hittat det perfekta vattenstrids-setet baserat på dina svar.</p><a class="kit-ready-btn" id="kit-ready-btn" href="#"><span class="kit-ready-btn-badge">40% RABATT</span><span class="kit-ready-btn-text">Se mitt rekommenderade set \u2192</span></a><div class="quiz-btn-wrap" style="margin-top:14px"><button class="quiz-btn-text" id="kit-retake-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Gör om quizet</button></div></div></div>';
      var delays = [0, 1400, 2800, 4200];
      CONFIG.loadingItems.forEach(function (_, i) {
        (setTimeout(function () {
          var item = el("load-item-" + i);
          item && item.classList.add("active");
        }, delays[i]),
          setTimeout(function () {
            var item = el("load-item-" + i),
              check = el("load-check-" + i);
            item &&
              check &&
              (item.classList.remove("active"),
              item.classList.add("done"),
              (check.textContent = "\u2713"));
          }, delays[i] + 1e3));
      });
      var lastDone = delays[delays.length - 1] + 1e3;
      setTimeout(function () {
        var kit = CONFIG.fixedKit,
          url = CONFIG.productUrl;
        kit.variantId &&
          kit.variantId.indexOf("REPLACE_") !== 0 &&
          (url += "?variant=" + kit.variantId);
        var spinner = el("loading-spinner");
        spinner && (spinner.style.display = "none");
        var sub = el("loading-sub");
        sub && (sub.style.display = "none");
        var ctaBtn = el("kit-ready-btn");
        ctaBtn && ctaBtn.setAttribute("href", url);
        var cta = el("loading-cta");
        cta && (cta.style.display = "");
        var rt = el("kit-retake-btn");
        rt &&
          rt.addEventListener("click", function () {
            ((state.screen = "intro"),
              (state.currentStep = 0),
              (state.answers = {}),
              renderIntro());
          });
        var pBar2 = el("quiz-progress-wrap");
        pBar2 &&
          (pBar2.innerHTML =
            '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Ditt set är klart!</span><span class="quiz-progress-count">' +
            total +
            " / " +
            total +
            '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
      }, lastDone);
    }
  }
  function advance() {
    var step = CONFIG.steps[state.currentStep];
    state.answers[step.id] &&
      (state.currentStep >= CONFIG.steps.length - 1
        ? renderLoading()
        : (state.currentStep++,
          renderStep(state.currentStep),
          window.scrollTo({ top: 0, behavior: "smooth" })));
  }
  function goBack() {
    if (state.currentStep <= 0) {
      ((state.screen = "intro"), (state.currentStep = 0), renderIntro());
      return;
    }
    (state.currentStep--,
      renderStep(state.currentStep),
      window.scrollTo({ top: 0, behavior: "smooth" }));
  }
  function init() {
    var root = el("quiz-root");
    root &&
      ((root.innerHTML =
        '<div id="quiz-wrapper"><div class="quiz-topbar"><span class="quiz-topbar-time">&lt;1 minut</span><span class="quiz-topbar-text">' +
        CONFIG.topBarText +
        '</span></div><header class="quiz-header"><img class="quiz-logo" src="' +
        CONFIG.logoUrl +
        '" alt="KiddoSpace"></header><div id="quiz-progress-wrap" style="display:none"></div><main id="quiz-stage" class="quiz-stage" aria-live="polite"></main></div>'),
      renderIntro());
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();